import { render, staticRenderFns } from "./jobTypeDetail.vue?vue&type=template&id=c573f9b2&"
import script from "./jobTypeDetail.vue?vue&type=script&lang=js&"
export * from "./jobTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports